import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const CREATE_QUERY = print(gql`
  mutation CreateEventClassification($data: CreateEventClassificationInput!) {
    createEventClassification(data: $data) {
      id
    }
  }
`);

export interface CreateGql {
  createEventClassification: {
    id: number;
  };
}
